export const productImage =
  'https://cdn.magicpatterns.com/uploads/p9ycLLNK1QQ1DVHxSXE25j/ChatGPT-Image-2-ago-2026_-08_06_43-p.m..webp'

export const checkoutUrl = 'https://boxing-coach-pro.impultienda.ar/checkout'

export const pains = [
  {
    emoji: '😰',
    title: 'Endless Training Planning',
    lines: [
      'Every week you spend hours...',
      'Creating new sessions...',
      'Building combinations...',
      'Planning conditioning...',
      'Preparing pad work...',
      'Organizing drills...',
      'Trying not to repeat the same workouts.',
      'Planning never ends.',
    ],
  },
  {
    emoji: '⚠️',
    title: 'Never Knowing What To Teach Next',
    lines: [
      'You constantly ask yourself...',
      'What should I teach today?',
      'Which combinations should we practice?',
      "How should I structure today's session?",
      'What should we improve next?',
      'Soon every class feels like starting over.',
    ],
  },
  {
    emoji: '📚',
    title: 'Coaching Resources Everywhere',
    lines: [
      'Drills.',
      'Combinations.',
      'Conditioning.',
      'Pad work.',
      'Training plans.',
      'Assessment forms.',
      'Everything exists...',
      "But it's spread across notebooks, videos, PDFs, folders, and years of coaching experience.",
      'Nothing is organized into one complete coaching system.',
    ],
  },
  {
    emoji: '😩',
    title: 'Coaching Burnout',
    lines: [
      'Planning.',
      'Organizing.',
      'Correcting.',
      'Preparing.',
      'Searching for new ideas.',
      'Repeating the process every week.',
      'Instead of doing what you enjoy most...',
      'Coaching your athletes.',
    ],
  },
]

export const modules = [
  {
    title: 'Boxing Drill & Combination Library™',
    description:
      'Ready-to-use boxing drills, combinations, footwork exercises, pad work, heavy bag training, partner drills, and technical progressions organized by level and objective.',
  },
  {
    title: 'Boxing Session Builder™',
    description:
      'Professional session templates with warm-ups, technical blocks, conditioning circuits, skill development, and complete training structures ready to use.',
  },
  {
    title: 'Ready-to-Use Boxing Sessions™',
    description:
      'Complete boxing sessions for beginner, intermediate, advanced, recreational, and competitive athletes.',
  },
  {
    title: 'Progressive Training Programs™',
    description:
      'Structured programs to improve technique, speed, power, endurance, footwork, defense, and overall boxing performance.',
  },
  {
    title: 'Boxing Coach Toolkit™',
    description:
      'Assessment forms, progress trackers, planning templates, attendance sheets, coaching documents, and professional resources ready to use.',
  },
  {
    title: 'High-Performance Coaching Systems™',
    description:
      'Season planning, competition preparation, weekly programming, athlete management, and advanced coaching systems.',
  },
]

export const bonuses = [
  {
    title: 'Complete Boxing Warm-Up & Activation Library™',
    description:
      'Professional boxing warm-ups, mobility routines, activation drills, and dynamic preparation systems ready to use before every training session.',
  },
  {
    title: 'Boxing Conditioning Circuits Vault™',
    description:
      'Ready-to-use conditioning circuits focused on speed, endurance, power, agility, and boxing-specific physical development.',
  },
  {
    title: 'Boxing Pad Work & Mitt Drill System™',
    description:
      'Professional mitt work combinations, reaction drills, technical progressions, and coaching systems ready to implement immediately.',
  },
  {
    title: 'Boxing Assessment & Athlete Progress Toolkit™',
    description:
      'Athlete evaluations, progress trackers, assessment forms, coaching documents, and performance monitoring tools organized for daily use.',
  },
  {
    title: 'Boxing Competition Preparation System™',
    description:
      'Competition planning templates, fight preparation schedules, coaching checklists, strategy planners, and performance organization tools ready to use.',
  },
]

export const benefits = [
  {
    emoji: '⚡',
    title: 'Save Hours Every Week',
    description:
      'Stop creating boxing sessions, technical drills, pad work routines, conditioning workouts, and training plans from scratch. Simply open the system, choose the right resources, and start every session fully prepared.',
  },
  {
    emoji: '👑',
    title: 'Coach With Greater Confidence',
    description:
      'Lead every class with structured training plans, organized progressions, professional coaching tools, and ready-to-use resources that eliminate uncertainty.',
  },
  {
    emoji: '🥊',
    title: 'Help Your Athletes Improve Faster',
    description:
      'Develop better technique, stronger footwork, faster combinations, improved conditioning, defensive skills, and overall boxing performance through structured training systems.',
  },
  {
    emoji: '😊',
    title: 'Deliver More Professional Coaching Sessions',
    description:
      'Use complete session plans, athlete assessments, progress trackers, coaching templates, and organized resources to provide a higher-level coaching experience every day.',
  },
]

export const testimonials = [
  {
    text: "I coach four group classes a night plus private athletes, and Sundays used to disappear into writing session plans. I opened the Session Builder, mapped my whole week in about forty minutes, and walked into the gym Monday with every round already structured. My classes flow better and I stopped repeating the same three combinations.",
    author: 'Mike D., 44',
    role: 'Head Boxing Coach',
    location: 'Philadelphia, Pennsylvania',
  },
  {
    text: "The pad work and mitt drill system is worth the price on its own. I had twenty years of combinations living in a beat-up notebook and in my head. Now everything is organized by objective and level, so I can hand a session to my assistant coach and know it will be run exactly the way I want it.",
    author: 'Ray T., 51',
    role: 'Boxing Gym Owner & Trainer',
    location: 'Houston, Texas',
  },
  {
    text: "I run fitness boxing classes and competitive training in the same gym, and the two used to blur together. Having ready-to-use sessions separated by level let me finally give recreational members a real progression while my amateurs get proper conditioning blocks. Retention in my beginner classes went up noticeably.",
    author: 'Danielle M., 36',
    role: 'Boxing Coach & Club Manager',
    location: 'Denver, Colorado',
  },
  {
    text: "Competition season was always chaos for me. The Competition Preparation System gave me a real timeline — weight management checkpoints, taper weeks, sparring plans, corner checklists. I took three amateurs to regionals with everything written down instead of improvised, and I was far calmer in the corner.",
    author: 'Carlos R., 39',
    role: 'Amateur Boxing Coach',
    location: 'Chicago, Illinois',
  },
  {
    text: "What sold me was the assessment toolkit. Parents and athletes want to see progress, and now I have trackers and evaluation forms I actually use every month. My athletes can see their footwork and defense scores improving, and it has made my program look and feel genuinely professional.",
    author: 'Anthony B., 47',
    role: 'Boxing Academy Director',
    location: 'Newark, New Jersey',
  },
]

export const faqs = [
  {
    question: 'Is this a physical product or a digital download?',
    answer:
      'This is a 100% digital product delivered instantly in high-quality PDF format. You can access it immediately from your computer, tablet, or smartphone.',
  },
  {
    question: 'Is this designed for professional boxing coaches?',
    answer:
      'Yes. This system was created specifically for boxing coaches who already understand the sport and need professional resources ready to use with their athletes. It is not a course on how to become a boxing coach.',
  },
  {
    question: 'Can I use it with athletes of different levels?',
    answer:
      'Absolutely. The system includes sessions, drills, progressions, conditioning programs, assessments, and coaching resources suitable for beginner, intermediate, advanced, recreational, and competitive athletes.',
  },
  {
    question: 'Can I use it for private coaching and group classes?',
    answer:
      'Yes. The material can be used for one-to-one coaching, small groups, boxing clubs, academies, fitness boxing classes, and competitive training environments.',
  },
  {
    question: 'Can I adapt the material to my coaching style?',
    answer:
      'Yes. Every session, drill, progression, assessment, and coaching resource can easily be adapted to your athletes, training environment, equipment, schedule, and coaching methodology.',
  },
  {
    question: 'Do I need a fully equipped boxing gym?',
    answer:
      'No. Many of the resources can be adapted to different facilities, available equipment, athlete levels, and training environments.',
  },
  {
    question: 'How quickly will I notice the benefits?',
    answer:
      'Most coaches begin saving planning time and feel more organized from the very first week because everything is already structured and ready to use.',
  },
  {
    question: 'When will I receive access?',
    answer:
      'Immediately after completing your purchase. The complete system will be delivered digitally by email within minutes.',
  },
  {
    question: 'Can I print the sessions and coaching documents?',
    answer:
      'Yes. Every session plan, drill sheet, assessment form, progress tracker, and planning template is print-ready so you can bring it straight to the gym floor.',
  },
  {
    question: 'Is this a one-time payment or a subscription?',
    answer:
      'It is a one-time payment of $27 USD. You receive the complete 6-in-1 system and all 5 premium bonuses with no recurring fees.',
  },
]

export const purchases = [
  { name: 'Mike D.', location: 'Philadelphia, Pennsylvania' },
  { name: 'Ray T.', location: 'Houston, Texas' },
  { name: 'Danielle M.', location: 'Denver, Colorado' },
  { name: 'Carlos R.', location: 'Chicago, Illinois' },
  { name: 'Anthony B.', location: 'Newark, New Jersey' },
  { name: 'Jordan W.', location: 'Las Vegas, Nevada' },
  { name: 'Steve K.', location: 'Detroit, Michigan' },
]
